// extracted by mini-css-extract-plugin
export default {"panel":"WhereWorksBest_panel__UGmT6","heading":"WhereWorksBest_heading__Dg2bZ","content":"WhereWorksBest_content__m7WVN"};